module.exports = __webpack_public_path__ + "img/toolsItem05.afb52bea.png";